<template>
  <div>
    <home-app-banner></home-app-banner>
    <home-app-content></home-app-content>
  </div>
</template>

<script>
  import HomeAppBanner from './HomeAppBanner'
  import HomeAppContent from './HomeAppContent'
  export default {
    components: {HomeAppContent, HomeAppBanner}, name: 'homeApp'
  }
</script>



// WEBPACK FOOTER //
// HomeApp.vue?1ec0d566